// Components/EditRateType.jsx
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../../../../api/axios";

const EditRateType = ({ open, onClose, rateType, onUpdated,roomTypes }) => {

  const [form, setForm] = useState({
    room_type_id: "",
    name: "",
    description: "",
    base_price: "",
    is_active: true,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    if (open && rateType) {
      setForm({
        room_type_id: rateType.room_type_id,
        name: rateType.name,
        description: rateType.description,
        base_price: rateType.base_price,
        is_active: rateType.is_active,
      });
    }
  }, [open, rateType]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await api.put(`/pms/rate-types/${rateType.id}`, form);

      Swal.fire({
        icon: "success",
        title: "Rate Type Updated",
        timer: 1200,
        showConfirmButton: false,
      });

      if (onUpdated) onUpdated();
      onClose();
    } catch (err) {
      console.error("Update failed:", err);
      Swal.fire({
        icon: "error",
        title: "Failed to update",
        text: err.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <>
      <div className="modal-backdrop fade show" />

      <div className="modal d-block">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Edit Rate Type</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <label className="form-label">Room Type</label>
                <select
                  className="form-select mb-2"
                  value={form.room_type_id}
                  onChange={(e) =>
                    setForm({ ...form, room_type_id: e.target.value })
                  }
                >
                  <option value="">Select Room Type</option>
                  {roomTypes.map((rt) => (
                    <option key={rt.id} value={rt.id}>
                      {rt.name}
                    </option>
                  ))}
                </select>

                <label className="form-label">Rate Type Name</label>
                <input
                  className="form-control mb-2"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                />

                <label className="form-label">Description</label>
                <textarea
                  className="form-control mb-2"
                  value={form.description}
                  onChange={(e) =>
                    setForm({ ...form, description: e.target.value })
                  }
                />

                <label className="form-label">Base Price</label>
                <input
                  type="number"
                  className="form-control mb-2"
                  value={form.base_price}
                  onChange={(e) =>
                    setForm({ ...form, base_price: e.target.value })
                  }
                />

                <div className="form-check mt-2 mb-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    checked={form.is_active}
                    onChange={() =>
                      setForm({ ...form, is_active: !form.is_active })
                    }
                  />
                  <label className="form-check-label">Active</label>
                </div>
              </div>

              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onClose}>
                  Close
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRateType;
